import { hot } from 'react-hot-loader';
import Container from '~/components/container';
import TeamListing from '~/components/team-listing';
import WipContent from '~/components/wip-content';
import AddTeamMember from '~/components/add-member';
import { ThemeProvider } from '~/theme';
import { Routes, Route, useLocation, Navigate } from 'react-router-dom';

const App = () => {
  const { pathname } = useLocation();

  if (pathname === '/') {
    return <Navigate to="/team" replace />;
  }

  return (
    <ThemeProvider>
      <Container>
        <Routes>
          <Route path="/team" element={<TeamListing />} />
          <Route path="/team/add" element={<AddTeamMember />} />
          <Route path="*" element={<WipContent />} />
        </Routes>
      </Container>
    </ThemeProvider>
  );
};

export default hot(module)(App);
